import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ColorPickerComponent } from './color-picker.component';
import { ClickOutsideDirective } from './click-outside.directive';

@NgModule({
    declarations: [
        ColorPickerComponent,
        ClickOutsideDirective
    ],
    imports: [
        CommonModule,
        FormsModule
    ],
    exports: [
        ColorPickerComponent
    ]
})
export class NcColorPickerModule { }